// Constants for getDeletionStats
export const GET_DELETION_STATS = "@deletion/GET_DELETION_STATS";
export type GET_DELETION_STATS = typeof GET_DELETION_STATS;

export const GET_DELETION_STATS_SUCCESS = "@deletion/GET_DELETION_STATS_SUCCESS";
export type GET_DELETION_STATS_SUCCESS = typeof GET_DELETION_STATS_SUCCESS;

export const GET_DELETION_STATS_FAILURE = "@deletion/GET_DELETION_STATS_FAILURE";
export type GET_DELETION_STATS_FAILURE = typeof GET_DELETION_STATS_FAILURE;
